import BaseService from "./BaseService";
import { IInstallation } from "../core/contracts/IInstallation";
// import { mockRequest, makeCustomerWithID /* , makeInstallationWithID*/ } from "./MockService";
import { SessionCache } from "../helpers/cache";
import { isArrayValid } from "../helpers/utility";
import CustomerModel from "../core/models/Customer";
import sortBy from "lodash/sortBy";
import get from "lodash/get";
import User from "../core/models/User";
import InstallationGroup from "../core/models/InstallationGroup";
import { IEnumerable } from "../core/models/ModelHelpers";

export default class InstallationService extends BaseService {
  async fetchAll(customer_id: string): Promise<CustomerModel> {
    try {
      const storage = new SessionCache();
      const cachedClients: CustomerModel[] | null = storage.get("customers");
      if (isArrayValid(cachedClients)) {
        const cachedInstallations = cachedClients?.find((x) => x.customer_id === customer_id);

        if (cachedInstallations) {
          return cachedInstallations;
        }
      } else {
        const cachedUser: User | null = storage.get("user");
        const cachedCustomer: InstallationGroup | undefined = get(
          cachedUser?.installationGroup?.filter((x) => x.id === customer_id),
          "[0]"
        );
        const cachedInstallationIds =
          (cachedCustomer?.installationList
            ?.map((x) => x.installationId)
            .filter((x) => x) as IEnumerable[]) ?? [];

        if (isArrayValid(cachedInstallationIds)) {
          try {
            const installationsFromAPI: IInstallation[] = await new InstallationService().fetchMultiple(
              cachedInstallationIds
            );
            return {
              customer_id: cachedCustomer?.id.toString() ?? "",
              customer_name: cachedCustomer?.name ?? "",
              installations: isArrayValid(installationsFromAPI)
                ? sortBy(installationsFromAPI, "product_description")
                : [],
            };
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log("InstallationService -> fetchAll → error", error);
            return new Promise((_, rej) => rej(error));
          }
        } else {
          return new Promise((_, rej) => rej("unable to resolve installations."));
        }
      }

      return new Promise((_, rej) => rej("unable to resolve installations."));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("InstallationService -> fetchAll -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }

  async fetch(installation_id: IEnumerable): Promise<IInstallation> {
    try {
      const APIResult: { installations: IInstallation[] } = await new BaseService().post<
        { installations: IInstallation[] },
        { installation_id: IEnumerable }[]
      >(`/installation/`, [{ installation_id: installation_id }]);

      if (isArrayValid(APIResult.installations)) {
        return APIResult.installations[0];
      }
      return new Promise((_, rej) => rej("unable to complete fetch"));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("InstallationService -> fetch -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }

  async fetchMultiple(installation_ids: IEnumerable[]): Promise<IInstallation[]> {
    const params = installation_ids.map((x) => {
      return { installation_id: x };
    });

    try {
      const APIResponse = await new BaseService().post<
        { installations: IInstallation[] },
        { installation_id: IEnumerable }[]
      >(`/installation/`, params);

      return APIResponse?.installations;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("InstallationService -> fetch -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }

  async search(searchParam: string) {
    try {
      return await new BaseService().get<IInstallation[]>(`/customer/?filter=${searchParam}`);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("InstallationService -> search -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }
}
